import apiClient from './axios';
import type {
  PaymentAccount,
  PaymentAccountInput,
  PaymentAccountUpdateInput,
  PaginatedListResponse,
} from '@cms/models';

export type PaymentAccountsListParams = {
  page?: number;
  pageSize?: number;
  search?: string;
  type?: 'BANK_TRANSFER' | 'CRYPTO';
  status?: string;
  sortBy?: 'name' | 'type' | 'status' | 'sortOrder';
  sortOrder?: 'asc' | 'desc';
};

export type PaymentAccountsListResponse = PaginatedListResponse<PaymentAccount>;

export const paymentAccountApi = {
  getPaginated: async (
    params: PaymentAccountsListParams = {}
  ): Promise<PaymentAccountsListResponse> => {
    const { page = 1, pageSize = 25, search, type, status, sortBy, sortOrder } = params;
    const response = await apiClient.get<PaymentAccountsListResponse>('/payment-accounts', {
      params: {
        page,
        pageSize,
        ...(search ? { search } : {}),
        ...(type ? { type } : {}),
        ...(status ? { status } : {}),
        ...(sortBy ? { sortBy } : {}),
        ...(sortOrder ? { sortOrder } : {}),
      },
    });
    return response.data;
  },

  getById: async (id: string): Promise<PaymentAccount> => {
    const response = await apiClient.get<PaymentAccount>(`/payment-accounts/${id}`);
    return response.data;
  },

  create: async (data: PaymentAccountInput): Promise<PaymentAccount> => {
    const response = await apiClient.post<PaymentAccount>('/payment-accounts', data);
    return response.data;
  },

  update: async (id: string, data: PaymentAccountUpdateInput): Promise<PaymentAccount> => {
    const response = await apiClient.patch<PaymentAccount>(`/payment-accounts/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/payment-accounts/${id}`);
  },
};
